import React from 'react'
import styled from 'styled-components'
import { Flex } from 'rebass'
import { getIcon } from '../Icon'

const FlexRowAndColumn = styled.section`
  display: flex;
  width: 100%;
  flex-flow: ${(props) => {
    let flexFlow = ''
    if (!props.selectedRemoteSelling) {
      flexFlow = 'row wrap'
    } else {
      flexFlow = 'column wrap'
    }
    return flexFlow
  }};

  @media (min-width: 768px) {
    flex-flow: row wrap;
  }
`

const FlexModified = styled(Flex)`
  text-align: ${(props) => {
    let textAlign = ''
    if (!props.selectedRemoteSelling) {
      textAlign = 'center'
    } else {
      textAlign = 'left'
    }
    return textAlign
  }};
  width: ${(props) => (!props.selectedRemoteSelling ? '33.33%' : '100%')};

  @media (min-width: 768px) {
    text-align: center;
  }
`

const TextStatus = styled.div`
  margin-top: auto;
  margin-bottom: auto;
`

const FlexRMSonMobile = styled(Flex)`
  text-align: left;
  width: ${(props) => {
    if (!props.selectedRemoteSelling) {
      return '100%'
    } else {
      return '33.33%'
    }
  }};

  @media (min-width: 768px) {
    text-align: center;
    width: ${(props) => {
      let colWidth = ''
      if (props.hasPayer && props.isNeedConfirmationLetter) {
        colWidth = '20%'
      } else if (!props.hasPayer) {
        colWidth = '20%'
      } else {
        colWidth = '25%'
      }
      return colWidth
    }};
  }
`

const EkycStatus = ({
  detail,
  selectedRemoteSelling,
  foreigner,
  hasPayer,
  isNeedConfirmationLetter,
  insuredOrPayer,
  hasConfirmationLetterFile,
  hasIdCardFile,
  hasPassportFile,
}) => {
  const icon = {
    success: 'ekycStatusSuccess',
    error: 'ekycStatusError',
    pending: 'ekycStatusPending',
  }

  const checkStatusDopa = () => {
    const { dopaResult } = detail
    if (dopaResult.verified && !dopaResult.dopaRequestFailed) {
      return 'success'
    }
    if (!dopaResult.verified && !dopaResult.dopaRequestFailed) {
      return 'error'
    }
    if (dopaResult.dopaRequestFailed || !dopaResult.response.data.message.includes('สถานะปกติ')) {
      return 'pending'
    }
    return ''
  }

  return (
    <FlexRowAndColumn>
      {/*For F2F TH*/}
      {!foreigner && !selectedRemoteSelling && (
        <FlexModified column width={1 / 3} px={'20px'} py={'10px'}>
          <TextStatus>หน้าบัตรประชาชน</TextStatus>
          <div>
            {detail?.frontIdCardResult && hasIdCardFile
              ? getIcon(icon[detail?.frontIdCardResult.verified ? 'success' : 'error'])
              : '-'}
          </div>
        </FlexModified>
      )}
      {!foreigner && !selectedRemoteSelling && (
        <FlexModified column width={1 / 3} px={'20px'} py={'10px'}>
          <TextStatus>หลังบัตรประชาชน</TextStatus>
          <div>
            {detail?.backIdCardResult ? getIcon(icon[detail?.backIdCardResult.verified ? 'success' : 'error']) : '-'}
          </div>
        </FlexModified>
      )}
      {!foreigner && !selectedRemoteSelling && (
        <FlexModified column width={1 / 3} px={'20px'} py={'10px'}>
          <TextStatus>DOPA</TextStatus>
          <div>{detail?.dopaResult ? getIcon(icon[checkStatusDopa()]) : '-'}</div>
        </FlexModified>
      )}
      {/*For RMS TH*/}
      {!foreigner && selectedRemoteSelling && (
        <FlexRMSonMobile
          column
          px={'20px'}
          py={'10px'}
          hasPayer={hasPayer}
          isNeedConfirmationLetter={isNeedConfirmationLetter}
          insuredOrPayer={insuredOrPayer}
        >
          <TextStatus>หน้าบัตรประชาชน</TextStatus>
          <div>
            {detail?.frontIdCardResult && hasIdCardFile
              ? getIcon(icon[detail?.frontIdCardResult.verified ? 'success' : 'error'])
              : '-'}
          </div>
        </FlexRMSonMobile>
      )}
      {!foreigner && selectedRemoteSelling && (
        <FlexRMSonMobile
          column
          px={'20px'}
          py={'10px'}
          hasPayer={hasPayer}
          isNeedConfirmationLetter={isNeedConfirmationLetter}
          insuredOrPayer={insuredOrPayer}
        >
          <TextStatus>หลังบัตรประชาชน</TextStatus>
          <div>
            {detail?.backIdCardResult ? getIcon(icon[detail?.backIdCardResult.verified ? 'success' : 'error']) : '-'}
          </div>
        </FlexRMSonMobile>
      )}
      {!foreigner && selectedRemoteSelling && (
        <FlexRMSonMobile
          column
          px={'20px'}
          py={'10px'}
          hasPayer={hasPayer}
          isNeedConfirmationLetter={isNeedConfirmationLetter}
          insuredOrPayer={insuredOrPayer}
        >
          <TextStatus>DOPA</TextStatus>
          <div>{detail?.dopaResult ? getIcon(icon[checkStatusDopa()]) : '-'}</div>
        </FlexRMSonMobile>
      )}
      {!foreigner && selectedRemoteSelling && (
        <FlexRMSonMobile
          column
          px={'20px'}
          py={'10px'}
          hasPayer={hasPayer}
          isNeedConfirmationLetter={isNeedConfirmationLetter}
          insuredOrPayer={insuredOrPayer}
        >
          <TextStatus>ความตรงกันของ ใบหน้า</TextStatus>
          <div>
            {detail?.idFaceRecognitionResult
              ? getIcon(icon[detail?.idFaceRecognitionResult.verified ? 'success' : 'error'])
              : '-'}
          </div>
        </FlexRMSonMobile>
      )}
      {!foreigner && selectedRemoteSelling && isNeedConfirmationLetter && (
        <FlexRMSonMobile
          column
          px={'20px'}
          py={'10px'}
          hasPayer={hasPayer}
          isNeedConfirmationLetter={isNeedConfirmationLetter}
          insuredOrPayer={insuredOrPayer}
        >
          <TextStatus>แบบแสดงความประสงค์ฯ โดยวิธีการทางอิเล็กทรอนิกส์</TextStatus>
          <div>
            {detail?.insurancePolicyAgreementResult && hasConfirmationLetterFile
              ? getIcon(icon[detail?.insurancePolicyAgreementResult.verified ? 'success' : 'error'])
              : '-'}
          </div>
        </FlexRMSonMobile>
      )}
      {/*For RMS None TH*/}
      {foreigner && selectedRemoteSelling && (
        <FlexModified column width={1 / 3} px={'20px'} py={'10px'}>
          <TextStatus>Passport</TextStatus>
          <div>
            {detail?.passportResult && hasPassportFile
              ? getIcon(icon[detail?.passportResult.verified ? 'success' : 'error'])
              : '-'}
          </div>
        </FlexModified>
      )}
      {foreigner && selectedRemoteSelling && (
        <FlexModified column width={1 / 3} px={'20px'} py={'10px'}>
          <TextStatus>ความตรงกันของ ใบหน้า</TextStatus>
          <div>
            {detail?.idFaceRecognitionResult
              ? getIcon(icon[detail?.idFaceRecognitionResult.verified ? 'success' : 'error'])
              : '-'}
          </div>
        </FlexModified>
      )}
      {foreigner && selectedRemoteSelling && isNeedConfirmationLetter && (
        <FlexModified column width={1 / 3} px={'20px'} py={'10px'}>
          <TextStatus>แบบแสดงความประสงค์ฯ โดยวิธีการทางอิเล็กทรอนิกส์</TextStatus>
          <div>
            {detail?.insurancePolicyAgreementResult && hasConfirmationLetterFile
              ? getIcon(icon[detail?.insurancePolicyAgreementResult.verified ? 'success' : 'error'])
              : '-'}
          </div>
        </FlexModified>
      )}
    </FlexRowAndColumn>
  )
}

export default EkycStatus
